import { readSessionPref, writeSessionPref } from './sessionPref';

/**
 * Préférence de debug « Tout l'arbre » (v0.49.0, A98) : quand elle est cochée,
 * l'onglet Arbre dessine **tous** les nœuds au lieu de ne dévoiler que ceux dont
 * le parent est acquis. Valable le temps de la session, **jamais** dans la
 * sauvegarde, et elle ne marque pas la partie (elle ne change rien au jeu).
 *
 * La case vit dans le panneau de debug (`[data-dev="tree-reveal"]`) ; l'écran
 * de l'Accalmie s'abonne pour redessiner l'arbre dès qu'elle change.
 */

const KEY = 'diceordie.debug.treeReveal';

const listeners = new Set<() => void>();

/** L'arbre entier doit-il être montré ? */
export function treeRevealAll(): boolean {
  return readSessionPref(KEY) === '1';
}

/** Règle la préférence et prévient les abonnés si elle a changé. */
export function setTreeRevealAll(on: boolean): void {
  if (treeRevealAll() === on) return;
  writeSessionPref(KEY, on ? '1' : '0');
  for (const fn of [...listeners]) fn();
}

/** S'abonne aux changements de la préférence ; renvoie le désabonnement. */
export function onTreeRevealChange(fn: () => void): () => void {
  listeners.add(fn);
  return () => {
    listeners.delete(fn);
  };
}
